import { createStore } from "vuex";
import menu from "./menu";
import tabs from "@/store/tabs";
import backgroundImg from "@/assets/imgs/login-background.png";
import systemTitle from "@/assets/imgs/login-head.png";
import codeBackgroundImg from "@/assets/imgs/login-error.png";
export default createStore({
  state: {
    backgroundImg: backgroundImg,
    systemTitle: systemTitle,
    isCode: codeBackgroundImg,
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    menu,
    tabs,
  },
});
